import _extends from "@babel/runtime/helpers/extends";
import { Box } from '@wix/design-system';
import React from 'react';
import { ECLIPSE_SALE_BG_COLOR, ECLIPSE_SALE_TEXT_COLOR } from '../../utils/consts';
export const EclipseBanner = _ref => {
  let {
    children,
    mobile = false,
    ...boxProps
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    paddingBottom: "SP3",
    paddingTop: "0",
    paddingLeft: "SP6",
    paddingRight: "SP6",
    width: "100%",
    boxSizing: "border-box"
  }, boxProps), /*#__PURE__*/React.createElement(Box, {
    backgroundColor: ECLIPSE_SALE_BG_COLOR,
    paddingTop: mobile ? '8px' : '9px',
    paddingBottom: mobile ? '8px' : '9px',
    paddingLeft: mobile ? '8px' : 'SP2',
    paddingRight: mobile ? '8px' : 'SP2',
    borderRadius: "12px",
    width: "100%",
    style: {
      color: ECLIPSE_SALE_TEXT_COLOR
    },
    gap: "SP1",
    align: "center",
    direction: "horizontal"
  }, children));
};
//# sourceMappingURL=EclipseBanner.js.map